import styled from '@emotion/styled';
import { themed, ITheme } from '../../themer';
import { Responsive } from '../../utils';
import { StyledArrowLinkButton } from '../Link';
import { ButtonWrap } from '../Button';

interface IStyledCallToActionProps {
	inverted?: boolean;
	hasDescription?: boolean;
}

export const StyledCallToAction = styled.div<IStyledCallToActionProps, ITheme>`
	padding: ${themed(({ callToAction }) => callToAction.padding)};
	background: ${themed(({ callToAction }, { inverted }) =>
		inverted
			? callToAction.background.inverted
			: callToAction.background.default,
	)};
	border-radius: ${themed(({ callToAction }) => callToAction.borderRadius)};

	${ButtonWrap} {
		margin-top: 0;
	}

	${({ hasDescription }) =>
		hasDescription &&
		`display: flex;
		justify-content: space-between;
		align-items: center;

		> div:first-of-type {
			margin-right:16px;
		}

		${ButtonWrap} > * {
			margin-top: 0;
		}

		@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
			flex-direction: column;
			align-items: flex-start;

			${ButtonWrap} > * {
				margin-top: 16px;
			}
		}
	`}

	h3 {
		margin-bottom: 30px;
		color: ${themed(({ callToAction }, { inverted }) =>
			inverted
				? callToAction.font.color.inverted
				: callToAction.font.color.default,
		)};
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		padding: ${themed(({ callToAction }) => callToAction.mobile.padding)};

		h3 {
			margin-bottom: 15px;
		}

		${StyledArrowLinkButton} {
			font-size: 16px;
			padding: 0 12px;
		}
	}
`;
